import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  containerStyle: {
    width: 650,
    backgroundColor: '#FFF',
    minHeight: 382,
    height: 382,
  },
  closeButton: {
    width: 40,
    height: 40,
    borderRadius: 8,
    backgroundColor: '#F5F7F8',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 30,
    right: 30,
    border: 'none',
    zIndex: 10,
  },
  mainContent: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 28,
    color: '#003353',
    fontWeight: '600',
    lineHeight: 28,
    marginTop: 40,
  },
  subtitle: {
    textAlign: 'center',
    fontSize: 18,
    color: '#003353',
    fontWeight: '400',
    lineHeight: 26,
    marginTop: 20,
    marginBottom: 40,
  },
  button: {
    minWidth: 224,
    minHeight: 56,
    marginBottom: 20,
  },
})
